import { createBrowserRouter, Link } from "react-router-dom";

import { RequireAuth } from "./auth";
import { Shell } from "./Shell";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { CampaignListPage } from "../features/campaigns/CampaignListPage";
import { CampaignDetailPage } from "../features/campaigns/CampaignDetailPage";
import { CampaignFormPage } from "../features/campaigns/CampaignFormPage";
import { AdvertiserListPage } from "../features/advertisers/AdvertiserListPage";
import { AdvertiserFormPage } from "../features/advertisers/AdvertiserFormPage";
import { ReportsPage } from "../features/reports/ReportsPage";
import { AdChainListPage } from "../features/mediation/AdChainListPage";
import { AppListPage } from "../features/apps/AppListPage";

/**
 * Routes.
 *
 * <p>Everything sits behind {@link RequireAuth}: there is no part of this panel that is meaningful
 * without an operator, and an unauthenticated visitor is sent to Keycloak rather than shown an
 * empty shell.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <Shell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },

      { path: "campaigns", element: <CampaignListPage /> },
      // Before ':id', or "new" would be read as a campaign identifier.
      { path: "campaigns/new", element: <CampaignFormPage /> },
      { path: "campaigns/:id", element: <CampaignDetailPage /> },
      { path: "campaigns/:id/edit", element: <CampaignFormPage /> },

      { path: "advertisers", element: <AdvertiserListPage /> },
      { path: "advertisers/new", element: <AdvertiserFormPage /> },
      { path: "advertisers/:id/edit", element: <AdvertiserFormPage /> },

      { path: "apps", element: <AppListPage /> },

      { path: "mediation", element: <AdChainListPage /> },

      { path: "reports", element: <ReportsPage /> },

      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-3 py-20 text-center">
      <h1 className="text-headline-md text-text-primary">
        Página no encontrada
      </h1>
      <p className="text-body-md text-text-secondary">
        La ruta que abriste no existe en el panel.
      </p>
      <Link to="/" className="text-body-md text-electric-blue hover:underline">
        Volver al panel
      </Link>
    </div>
  );
}
